import { styled, Grid, Button } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const Body = styled(Grid)(({ theme }) => ({
  gap: 40,
}));
